import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Params } from '../../../../../transactions/pages/list/models/params.model';
@Component({
  selector: 'app-flow-custom-services',
  templateUrl: './flow-custom-services.component.html',

})
export class FlowCustomServicesComponent implements OnInit {

  @Input() custom_service: any;
  expandedStepState: boolean = true;
  model: any = {};
  params: Params;
  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.params = new Params(params);
      this.model.partner = params.get('partner');
      this.model.account = params.get('account');
    });
    this.model.custom_service = this.custom_service;
  }
}
